import { isEmpty } from '../../../utils'

export const regionProps = {
  value: {
    type: Array
  },
  // title
  name: {
    type: String,
    default: ''
  },
  // 未选择时展示的默认文案
  placeholder: {
    type: String,
    default: '请选择地区',
    require: true
  },
  // radio
  radio: {
    type: Boolean,
    default: true
  },
  //
  multiple: Boolean,
  // 调整尺寸

  size: {
    type: String,
    default: 'small'
  },
  // 是否只读
  disabled: {
    type: Boolean,
    default: false
  },
  // 是否展示省
  showProvince: {
    type: Boolean,
    default: true
  },
  // 是否展示城市
  showCity: {
    type: Boolean,
    default: true
  },
  showCounty: {
    type: Boolean,
    default: true
  },
  showTown: {
    type: Boolean,
    default: true
  },
  // 纯文本
  isPureText: {
    type: Boolean,
    default: true
  }
}

const transfer = ({provinceName, cityName, countyName, townName}) => {
  const module = {
    'showProvince': provinceName,
    'showCity': cityName,
    'showCounty': countyName,
    'showTown': townName
  }
  const arr = []

  for (let k in module) {
    arr.push(module[k] || '')
  }
  return arr.join(' ').replace(/(^\s*)|(\s*$)/g, '')
}

const cb = (value, field) => {
  if (field.radio) {
    return transfer(value)
  }
  if (Array.isArray(value)) {
    return value.map(v => transfer(v)).join(',')
  }
}

export function initValue (value, field) {
  return isEmpty(value) ? '-' : cb(value, field)
}